import { gql } from '@apollo/client';

export const GQL_GET_CAMERAS = gql`
  query GET_CAMERAS {
    client {
      name
    }
    cameras {
      id
      name
      client {
        name
        id
      }
    }
  }
`;

export const GQL_GET_CAMERA_GOTO = gql`
  query GET_CAMERA_DETAIL($cameraId: ID!) {
    camera(id: $cameraId) {
      id
      rtspUrl
      url
      credentials {
        username
        password
      }
    }
  }
`;

export const GQL_GET_CAMERA_DETAIL = gql`
  query GET_CAMERA_DETAIL($cameraId: ID!) {
    account {
      id
      roles
    }
    camera(id: $cameraId) {
      id
      name
      timezone
      client {
        id
        name
        active
        demo
      }
      status {
        time
        lastChange
        http {
          online
          replied
          timeout
          error
          errorMessage
          auth
        }
        rtsp {
          online
          connected
          requested
          timeout
          error
          responseCode
        }
      }
    }
    players(cameraId: $cameraId) {
      id
      name
      settings
    }
  }
`;

export const GQL_GET_CAMERA_INFO_FOR_NEW_PLAYER = gql`
  query GET_CAMERA_INFO_FOR_NEW_PLAYER($cameraId: ID) {
    camera(id: $cameraId) {
      id
      name
      client {
        id
        name
      }
      longitude
      latitude
      timezone
      timezoneAsPack
      record {
        fastPlaybacks {
          speed
        }
      }
      frameCaptures {
        captures {
          ref
        }
      }
      panoramas {
        ref
      }
      server {
        subdomain
      }
    }
  }
`;

export const GQL_GET_CAMERA = gql`
  query GET_CAMERA($cameraId: ID) {
    camera(id: $cameraId) {
      id
      name
      client {
        id
        name
      }
      controlTime
      active
      keepConnected
      latitude
      longitude
      timezone
      model
      server {
        id
        subdomain
        ip
      }
      settings
      record {
        enabled
        storage
        time
        fastPlaybacks {
          speed
          bandwidth
          framerate
          storage
          time
        }
      }
      alert {
        enabled
        interval
        emails
      }
      frameCaptures {
        id
        cron
        size
        priority
        captures {
          ref
          wait
          position {
            pan
            tilt
            zoom
          }
        }
      }
      allowedDomains
      panoramas {
        id
        ref
      }
    }
    servers {
      id
      subdomain
    }
  }
`;

export const GQL_RTSP_PUSH_LIST = gql`
  query RTSP_PUSH_LIST($cameraId: ID!) {
    pushs(cameraId: $cameraId) {
      start
      camera
      container
      url
      mute
      acodec
      cmd
    }
  }
`;

export const GET_RECORD_INFO = gql`
  query GET_RECORD_INFO($cameraId: ID, $ttl: Float) {
    recordInfo(id: $cameraId, ttl: $ttl) {
      camera
      speeds {
        speed
        start
        end
      }
    }
  }
`;
